import { render, staticRenderFns } from "./mpci.vue?vue&type=template&id=8edd5acc&scoped=true"
import script from "./mpci.vue?vue&type=script&lang=js"
export * from "./mpci.vue?vue&type=script&lang=js"
import style0 from "./mpci.vue?vue&type=style&index=0&id=8edd5acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edd5acc",
  null
  
)

export default component.exports